export default {
    SET_PROPERTIES(state, properties) {
        state.properties = properties;
    },
};
